import jwtDecode from 'jwt-decode';
import { renameObjectProperty } from '../../utils';

import { AuthGrantType } from '../services/auth-token-grant';

import { SerializableObject } from './serializable-object';
import { TokenClaims } from './token-claims.do';

/**
 * Session object holding the tokens used to access Mobiz protected resources.
 */
export class MobizSession extends SerializableObject {
	// TODO: TP-9490 Refactor, these properties should always be defined and they should be readonly.
	public accessToken: string | null;
	public expiresIn: number | null;
	// TODO: Update the API to include the AuthGrantType in session data.
	public grantType: AuthGrantType;
	public refreshToken: string | null;
	public scope: string | undefined;
	public tokenType: string | null;

	private tokenClaims?: TokenClaims;

	public buildFromJSON(json: Object): void {
		// NOTE: Properties from the backend are in snake_case, those from storage are in camelCase.
		renameObjectProperty(json, 'access_token', 'accessToken');
		renameObjectProperty(json, 'expires_in', 'expiresIn');
		renameObjectProperty(json, 'grant_type', 'grantType');
		renameObjectProperty(json, 'refresh_token', 'refreshToken');
		renameObjectProperty(json, 'token_type', 'tokenType');
		super.buildFromJSON(json);
	}

	/**
	 * Decodes the access token and extracts the claims.
	 */
	public getClaimsForAccessToken(): TokenClaims | never {
		if (!this.tokenClaims) {
			const sessionAccessToken: string | null = this.accessToken;
			// TODO: TP-9490 Refactor, this check should not be needed here.
			if (!sessionAccessToken || sessionAccessToken.length === 0) {
				throw new Error('No access token available.');
			}
			this.tokenClaims = new TokenClaims(jwtDecode(sessionAccessToken));
		}
		return this.tokenClaims;
	}
}
